// eslint-disable-next-line import/prefer-default-export

export const scrollCarouselToHighlightedProduct = (productCard) => {
  if (productCard) {
    const carouselContainer = productCard.closest(
      "[data-carousel_container='true']"
    )
    setTimeout(() => {
      carouselContainer.scrollTo({
        behavior: 'smooth',
        left:
          productCard.offsetLeft -
          (window.innerWidth - productCard.scrollWidth) / 2,
      })
    }, 0)
  }
}

const getRectBoundByProductID = (productID) => {
  const headerElement = document.querySelector(
    `[data-msp_product_id*="${productID}"]`
  )
  if (headerElement) {
    return headerElement.getBoundingClientRect()
  }
  return {}
}

export const handleProductCarouselHighlighting = (
  rootBounds,
  products,
  setActiveProductID
) => {
  const firstProductRect = getRectBoundByProductID(products[0].productID)
  const lastProductRect = getRectBoundByProductID(
    products[products.length - 1].productID
  )
  let isAnyProductInView = false
  let currentProductID
  for (let i = 0; i < products.length; i += 1) {
    currentProductID = products[i].productID
    const currentProductRect = getRectBoundByProductID(currentProductID)
    if (
      currentProductRect.top > rootBounds.top &&
      currentProductRect.top < rootBounds.bottom
    ) {
      setActiveProductID(currentProductID)
      isAnyProductInView = true
      break
    }
  }
  if (
    !isAnyProductInView &&
    (rootBounds.bottom < firstProductRect.top ||
      lastProductRect.bottom < rootBounds.top)
  ) {
    setActiveProductID('')
  }
}

export const getSliderSettings = (cardLayout) => {
  const sliderSettings = {
    slidesToShow: cardLayout === 'horizontal' ? 1 : 2,
    slidesToScroll: cardLayout === 'horizontal' ? 1 : 2,
    cellSpacing: 16,
    responsive: [
      {
        minWidth: 484,
        maxWidth: 509,
        settings: {
          slidesToShow: cardLayout === 'horizontal' ? 2 : 3,
          slidesToScroll: cardLayout === 'horizontal' ? 2 : 3,
        },
      },
      {
        minWidth: 510,
        maxWidth: 999,
        settings: {
          cellSpacing: 32,
          slidesToShow: cardLayout === 'horizontal' ? 2 : 3,
          slidesToScroll: cardLayout === 'horizontal' ? 2 : 3,
        },
      },
      {
        minWidth: 1000,
        maxWidth: 2000,
        settings: {
          cellSpacing: 16,
          slidesToShow: cardLayout === 'horizontal' ? 3 : 6,
          slidesToScroll: cardLayout === 'horizontal' ? 3 : 6,
        },
      },
    ],
  }
  return sliderSettings
}
